import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProviderAdmin } from './context/AuthContextAdmin';
import { AuthProviderPublic } from './context/AuthContextPublic';
import { AuthProviderClient } from './context/AuthContextClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProviderAdmin>
        <AuthProviderPublic>
          <AuthProviderClient>
            <App />
          </AuthProviderClient>
        </AuthProviderPublic>
      </AuthProviderAdmin>
    </BrowserRouter>
  </React.StrictMode>
);
